/* tslint:disable:ordered-imports */
import { NgModule, inject } from '@angular/core';
import { FlxCoreModule } from '@fluxys/core';
import { FlxSecurityModule } from '@fluxys/security';
// import { FlxHttpModule } from '@fluxys/angular/http';
import { TranslocoModule } from '@jsverse/transloco';

import { environment } from '../../environments/environment';
import { CoreDataService } from '../shared/services/core-data.service';
import { FlxCommonModule } from "@fluxys/common";
import { FlxPrimengModule } from "@fluxys/primeng";
import { FlxGSmartModule } from "@fluxys/gsmart";
import { FlxLayoutModule } from "@fluxys/gsmart/layout";


@NgModule({
  imports: [
    TranslocoModule,
    // FlxHttpModule.forRoot(),
    FlxSecurityModule.forRoot(),
    FlxCommonModule.forRoot({ availableLanguages: ['en'], defaultLanguage: 'en' }),
    FlxCoreModule.forRoot({ gitHash: environment.version.sha }),
    FlxPrimengModule.forRoot(),
    FlxGSmartModule.forRoot(),
    FlxLayoutModule.forRoot(),
  ]
})
export class CoreModule {
  private readonly module = inject(CoreModule, { optional: true, skipSelf: true });
  private readonly coreDataService = inject(CoreDataService);


  // @ts-ignore
  constructor() {
    const module = this.module;


    if (module != undefined) {
      throw new Error(`The core module can only be used in the AppModule class.`);
    }

  }
}
